import * as types from './constants.js';
import { GetRequest } from '../../../Api';

export const CreateMix = (data) => {
    return (dispatch) => {
        dispatch({
            type: types.CREATE_MIX,
            payload: data
        });
    };
};

export const GetMix = (token) => {
    return (dispatch) => {
        dispatch(SongsLoading(true));

        let result = GetRequest({}, token, 'mix');

        result
            .then(({ data }) => {
                dispatch({
                    type: types.LOAD_MIX,
                    payload: data
                });
                dispatch(SongsLoading(false));
            })
            .catch((error) => {
                console.log(error);
                dispatch(SongsLoading(false));
            });
    };
};

export const SongsLoading = (isLoading) => {
    return (dispatch) => {
        dispatch({
            type: types.LOADING_STATUS,
            payload: isLoading
        });
    };
};
